<div>
  <h4 class="category-name">{{ technologyCategory?.categoryName }}</h4>
  <div class="technology" *ngFor="let item of technologyCategory?.technologyItems">
    <img class="technology-icon" [src]="item?.icon" />
    <span *ngIf="!item?.website">{{ item?.name }}</span>
    <a *ngIf="item?.website" href="{{ item.website }}" target="_blank">{{ item?.name }}</a>
  </div>
</div>
